import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "savnt_admin_pwd";

export const getStoredPassword = () => localStorage.getItem(STORAGE_KEY) || "";
export const setStoredPassword = (p) => localStorage.setItem(STORAGE_KEY, p);
export const clearStoredPassword = () => localStorage.removeItem(STORAGE_KEY);

const adminAxios = () => {
    return axios.create({
        baseURL: `${BACKEND}/api/admin`,
        headers: { "X-Admin-Password": getStoredPassword() },
    });
};

export const adminLogin = async (password) => {
    const { data } = await axios.post(`${BACKEND}/api/admin/login`, { password });
    if (data?.ok) {
        setStoredPassword(password);
    }
    return data?.ok === true;
};

export const adminFetchOrders = async () => {
    const { data } = await adminAxios().get("/orders");
    return data;
};

export const adminSendChat = async (message, sessionId) => {
    const { data } = await adminAxios().post("/chat", { message, session_id: sessionId || null });
    return data;
};


export const adminFetchReviews = async (status = "pending") => {
    const { data } = await adminAxios().get(`/reviews`, { params: { status } });
    return data;
};

export const adminApproveReview = async (id) => {
    const { data } = await adminAxios().post(`/reviews/${id}/approve`);
    return data;
};

export const adminDeleteReview = async (id) => {
    const { data } = await adminAxios().delete(`/reviews/${id}`);
    return data;
};
